/**
 * Total Number of policies, Policy Holders and Insured Persons
 */

import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

const header = [
	[
		"Template 05 - Total Number of policies, Policy Holders and Insured Persons"
	],
	["Number", "Standard Plan", "Flexi Plan"]
]

const rows = policies => [
	[
		"Policies",
		countPolicies(policies, "S00027"),
		countPolicies(policies, "F00038")
	],
	[
		"Policy Holders",
		countPolicyHolders(policies, "S00027"),
		countPolicyHolders(policies, "F00038")
	],
	[
		"Insured Persons",
		countPolicies(policies, "S00027"),
		countPolicies(policies, "F00038")
	]
]

const countPolicies = (policies, plan) => {
	return policies.filter(
		policy =>
			policy?.status === "ISSUED" &&
			policy?.product?.productId?.plan?.includes(plan)
	).length
}

const countPolicyHolders = (policies, plan) => {
	const otherPolicyHolders = policies
		.filter(
			policy =>
				policy?.status === "ISSUED" &&
				policy?.product?.productId?.plan?.includes(plan)
		)
		.map(policy => {
			return policy?.otherContractHolders?.length || 0
		})
		.reduce((a, b) => {
			return a + b
		}, 0)

	const primaryHolders = policies.filter(
		policy =>
			policy.status === "ISSUED" &&
			policy?.product?.productId?.plan?.includes(plan)
	).length

	return otherPolicyHolders + primaryHolders
}

const fetchData = async filterPayload => {
	const query = gql`
		query fetchTemplate05Payload($policyWhere: policyWhereInput) {
			policies(where: $policyWhere) {
				list {
					status
					otherContractHolders {
						id
					}
					product {
						productId {
							plan
						}
					}
				}
			}
		}
	`
	const variables = {
		policyWhere: filterPayload
	}

	const res = await api({ query, variables })

	return res?.data?.policies?.list
}

export default async filterPayload => {
	const fetchedData = await fetchData(filterPayload)
	const workSheetData = [...header, ...rows(fetchedData)]
	const workSheetColumns = header.map(item => {
		return { wpx: 150 }
	})
	const workSheetMerges = [
		{
			s: { r: 0, c: 0 },
			e: { r: 0, c: 6 }
		}
	]
	return { workSheetData, workSheetColumns, workSheetMerges }
}
